import { formatDynamicFields } from 'utils/graphqlUtils'

export const patientSearchModelFields = `
  id
  statusType
  tagKeywords
`

export const searchPatientSearchModels = (fields = patientSearchModelFields) => /* GraphQL */ `
  query SearchPatientSearchModels(
    $filter: SearchablePatientSearchModelFilterInput
    $sort: SearchablePatientSearchModelSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPatientSearchModels(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      nextToken
      total
      items {
        ${formatDynamicFields(fields)}
      }
    }
  }
`
